<div style="text-align: center; flex-grow: 1">
  @if (dialogConfig.data.question !== undefined && dialogConfig.data.question.length > 0) {
    {{ dialogConfig.data.question }}
  } @else {
    Are you sure you want to
    {{ dialogConfig.data.action?.charAt(0).toLowerCase() + dialogConfig.data.action?.slice(1) || 'delete' }}:
  }
  <h4>{{ objectName }}</h4>
</div>

<footer style="width: auto; display: flex; flex-shrink: 0; padding: 2% 0; justify-content: space-between">
  <p-button [raised]="true" severity="danger" (click)="confirm()">{{ actionName }}</p-button>
  <span class="ebo-spacer"></span>
  <!-- variant="outlined" -->
  <p-button [raised]="true" variant="outlined" (click)="close($event)">
    {{ actionName === 'Cancel' ? 'Abort' : 'Cancel' }}
  </p-button>
</footer>
